import {
   Patient,
   PatientNote,
   PatientNoteQuery,
   PatientNoteRemoveCommand,
} from '@dreryk/egabinet-patient-frontend-api';

import {
   useCqrsCommand,
   UseCqrsCommandResult,
   UseCqrsQueryResult,
   useCqrsSearch,
} from '@dreryk/command-query-react-common';
import { Direction, paginations } from '@dreryk/command-query-ws-client';
import { Slot } from '@dreryk/watermelon';

export const usePatientNoteQuery = (patientId: Patient['id']): UseCqrsQueryResult<PatientNote[]> => {
   return useCqrsSearch<PatientNote>(() => {
      const query = new PatientNoteQuery();
      query.patientId = Slot.of(patientId);
      return query;
   }, paginations.all<PatientNote>().orderedBy('lastModificationDate', Direction.DESCENDING));
};

export const usePatientNoteRemoveCommand = (onSuccess: () => void): UseCqrsCommandResult<void, PatientNote['id']> => {
   return useCqrsCommand<void, PatientNote['id']>(
      (patientId) => {
         const command = new PatientNoteRemoveCommand();
         command.id = patientId;
         return command;
      },
      {
         onSuccess: onSuccess,
      }
   );
};
